/* =============================================================
   PawShift — ps-reviews-page.js
   Filter pills for the standalone reviews page.
   "trust" tagged cards are always visible regardless of filter.
   ============================================================= */

(function () {
  'use strict';

  const grid = document.getElementById('ps-rp-grid');
  if (!grid) return;

  const filterBtns = document.querySelectorAll('.ps-rp__filter-btn');

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      var tag = btn.dataset.filter;
      grid.querySelectorAll('.ps-rp__card').forEach(function (card) {
        var cardTag = card.dataset.tag;
        card.style.display = (tag === 'all' || cardTag === tag || cardTag === 'trust') ? '' : 'none';
      });
    });
  });
})();
